import React from 'react';
import { useNavigate } from 'react-router-dom';
import URL from '@/common/routes/Url';
import './css/privacyStyle.scss';

const Privacy: React.FC = () => {
  const navigate = useNavigate();

  const tologin = () => {
    navigate(URL.privacy);
  }

  return (
    <div className='privacy'>
      <header>
        <h1 className="ttl">
          <img src="/manual/sample/images/logo.png" alt="次世代ホワイトボード みてリンク" />
        </h1>
        <ul className="list">
          <li>
            <a href="/signin">ログイン</a>
          </li>
          <li>
            <a href="/home">ホーム</a>
          </li>
          <li>
            <a href="https://si.mitani-corp.co.jp/lp/mitelink-form/">
              お問い合わせ
            </a>
          </li>
          <li>
            <a href="/home/privacy">プライバシーポリシー</a>
          </li>
          <li>
            <a href="/manual/terms.pdf" target='_blank'>
              利用規約
            </a>
          </li>
        </ul>
      </header>
      <body>
        <h2>個人情報の取り扱いについて</h2>
        <div>三谷商事株式会社（以下「当社」といいます。）は、個人情報の取扱いに関する方針を次のとおり定めます。なお、本文中の用語の定義は、個人情報の保護に関する法律（以下「個人情報保護法」といいます。）及び関連法令によります。</div>
        <h3>関係法令・ガイドライン等の遵守</h3>
        <div className='text'>当社では、個人情報保護法その他の関係法令、個人情報保護委員会の定めるガイドライン等及び本プライバシーポリシーを遵守し、個人情報を適法かつ適正に取り扱います。</div>
        <h3>個人情報の取得</h3>
        <div className='text'>当社は、お客様（取引先様等含む。以下同じ）の個人情報を適法かつ適正な手段により取得します。詳細は「
          <a href="/manual/mcl.f.oct.2017.pdf" target='_blank'>当社における個人情報の取扱いについて</a>
          」をご覧下さい。</div>
        <h3>個人情報の利用目的</h3>
        <div className='text'>当社は、お客様の個人情報について、「
          <a href="/manual/mcl.f.oct.2017.pdf" target='_blank'>当社における個人情報の取扱いについて</a>
          」に記載する利用目的の範囲内又はその取得状況から明らかである利用目的の範囲内で利用し、ご本人の同意がある場合又は法令で認められている場合を除き、他の目的で利用しません。</div>
        <h3>外部へのリンクにともなう個人情報の取扱い</h3>
        <div className='text'>弊社が運営するウェブサイトは外部へのリンクを含んでいる場合があります。外部サイトにおける個人情報の取扱いや管理状況、掲載内容に関して弊社は責任を負いません。直接リンク先サイトへお問合わせください。</div>
        <h3>個人データの委託</h3>
        <div className='text'>当社は、業務を円滑に進めお客様により良いサービスを提供するため、お客様の個人データの取扱いを協力会社に委託する場合があります。ただし、委託する個人データは、委託する業務を遂行するのに必要最小限の情報に限定します。</div>
        <h3>個人データの第三者提供</h3>
        <div className='text'>当社は、お客様ご本人の事前同意がある場合又は法令で認められている場合を除き、お客様の個人データを第三者（委託先を除きます。）に提供いたしません。</div>
        <h3>個人データの管理</h3>
        <h4>（１）データ内容の正確性の確保</h4>
        <div className='text'>当社は、お客様の個人データにつき、利用目的の達成に必要な範囲内において、正確かつ最新の内容に保つとともに、利用する必要がなくなったときは当該個人データを消去するよう努めます。</div>
        <h4>（２）安全管理措置</h4>
        <div className='text'>当社は、お客様の個人データの漏えい、滅失又は毀損の防止その他の安全管理のために必要かつ適切な安全管理措置を講じます。</div>
        <h4>（３）従業者の監督</h4>
        <div className='text'>当社は、お客様の個人データを従業者に取り扱わせるに当たっては、個人情報の適正な取扱いを周知徹底するとともに適正な教育を行い、必要かつ適切な監督を行います。</div>
        <h4>（４）委託先の監督</h4>
        <div className='text'>当社は、お客様の個人データの取扱いを委託する場合には、委託先には適切な安全管理措置を講じている関連会社、協力会社及び個人を選定し、委託先に対し必要かつ適切な監督を行います。</div>
        <h3>プライバシーポリシーの改定について</h3>
        <div className='text'>当社は、本プライバシーポリシーの内容を適宜見直し、必要に応じて変更することがあります。その場合、改定版の公表の日から変更後のプライバシーポリシーが適用されることになります。</div>
        <div className='foot'>当社における個人データの取扱いに関するご質問やご苦情に関しては、「
          <a href="/manual/mcl.f.oct.2017.pdf" target='_blank'>当社における個人情報の取扱いについて</a>
          」に記載する個人情報窓口にご連絡ください。</div>
        <div className='foot'>2017年11月7日改定</div>
        <div className='foot'>三谷商事株式会社</div>
      </body>
      <footer>
        <div className="infoWrap">
          <div className="flex">
            <div className="box">
              <img src="/manual/sample/images/ftr_logo.png" alt="三谷商事株式会社" />
              <img src="/manual/sample/images/ftr_name.png" alt="情報システム事業部システム部" />
            </div>
            <div className="box2">
              <div className="info">
                <img src="/manual/sample/images/ftr_icon_phone.png" alt="フリーダイヤル" />
                <a href="tel:0120-188-022">0120-188-022</a>
              </div>
              <div className="info2">受付時間 9:00-12:00 13:00-17:00</div>
              <div className="info3">
                <img src="/manual/sample/images/ftr_icon_mail.png" alt="メールアドレス" />
                <a href="mailto:mitelink@mitani-corp.co.jp">
                  mitelink@mitani-corp.co.jp
                </a>
              </div>
            </div>
          </div>
          <div className='footer'>
            <ul className="md-flex">
            <li><a href="/home">ホーム</a></li>
              <li className='ll'><a href="/home/overview">会社概要</a></li>
              <li className='ll'><a href="/home/sct">特定商取引法に基づく表記</a></li>
              <li className='ll'><a href="/home/privacy">プライバシーポリシー</a></li>
              <li className='ll'><a href="/manual/terms.pdf" target='_blank'>利用規約</a></li>
            </ul>
          </div>
        </div>
      </footer>
    </div>
  );
}
export default Privacy;